// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"5ec73905","603":"dc7b87b5"}[chunkId] + ".chunk.js";
};